import styles from "./TypeFilter.module.css";
import ToggleButton from "../../UI/ToggleButton";

const allServiceTypes = ["Privatni", "Poslovni", "Sezonski"];

export default function TypeFilter({
    serviceTypes,
    setServiceTypes,
    alwaysMobileLayout = false,
}) {
    const toggleserviceType = (type) => {
        setServiceTypes([type]);
    };

    return (
        <div
            className={`${styles[`type-filter-container`]} ${
                alwaysMobileLayout === true &&
                styles[`type-filter-container-mobile`]
            }`}
        >
            <div
                className={`${styles[`type-filter-title`]} ${
                    alwaysMobileLayout === true &&
                    styles[`type-filter-title-mobile`]
                }`}
            >
                Izaberite vrstu korisnika:
            </div>
            <div
                className={`${styles[`type-filter`]} ${
                    alwaysMobileLayout === true && styles[`type-filter-mobile`]
                }`}
            >
                {allServiceTypes.map((type, index) => {
                    return (
                        <div
                            className={`${styles[`type-button`]} ${
                                alwaysMobileLayout === true &&
                                styles[`type-button-mobile`]
                            }`}
                            key={index}
                        >
                            <ToggleButton
                                active={
                                    serviceTypes.length === 1 &&
                                    serviceTypes[0] === type
                                }
                                onClick={() => toggleserviceType(type)}
                            >
                                {type}
                            </ToggleButton>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
